const CLOUDINARY_IMAGE_HOST = 'cms.cloudinary.vpsvc.com';
const BREAKPOINTS = [
  '512w',
  '768w',
  '1024w',
  '1280w',
  '1500w',
  '2400w',
  '3000w',
  '3780w',
];

// TODO: move this function to a separate lib if it proves useful ;)
// This function should be used to fill the srcset attribute in the <img> tag
export default function getResponsiveCloudinaryImage(imageSrc: string): string {
  if (
    imageSrc === undefined ||
    imageSrc === null ||
    !imageSrc.includes(CLOUDINARY_IMAGE_HOST)
  ) {
    throw new Error(`Include a valid cloudinary Image url ${imageSrc}`);
  }
  return BREAKPOINTS.map(
    (breakpoint) =>
      `${imageSrc
        .replace(/(,)?(w_[0-9]+)(,|\/)?/, '')
        .replace(
          '/upload/',
          `/upload/w_${breakpoint.replace('w', '')}/`
        )} ${breakpoint}`
  ).join(',');
}
